/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var QreUserElement = new Class({
  Extends: QuriobotElement,
  template: function () {
    var base =
      '<div class="answer--bubble by--user isLoading {{ render }}" family="{{ key }}" id="{{ eid }}">' +
      '    <div class="answer-body__wrapper">' +
      '        <div class="answer--body update">' +
      '            {{ content }}' +
      '        </div>' +
      '        <button type="button" aria-label="' +
      this.data.i18n.redo.button.title +
      '" class="icon--redoWrapper">' +
      '            <div class="redo"></div>' +
      '        </button>' +
      '    </div>' +
      '</div>'

    return { base: base }
  },
  attach: function () {
    this.element.addEvents({
      update: function (data) {
        this.element.getElements('.update')[0].set('html', data.content)
        if (!this.element.hasClass('redo--ready')) {
          this.renderCallback(this.data, this.data.eid, true)
        } else {
          this.element.removeClass('redo--ready')
        }
      }.bind(this),
    })
  },
})
